// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyB1uy1L90aOgIa6XcDa7m8vevGrqRlg0hc",
  authDomain: "intrasense-dev.firebaseapp.com",
  projectId: "intrasense-dev",
  storageBucket: "intrasense-dev.firebasestorage.app",
  messagingSenderId: "98362755721",
  appId: "1:98362755721:web:974e95da2e1a2ff66d5458",
  measurementId: "G-RM8E5L857J",
};

// Firebase Console -> Project Settings -> Cloud Messaging -> Web configuration -> Web Push certificates.
// This key must belong to the project above - a key from another project makes FCM reject the
// subscription with a 401. Push registration is skipped while this is empty.
export const firebaseVapidKey = "BM1mvO-SQAQcxxh--aayWHTXwXS6KLrYlv-nZ_LeqNDEdks4wc_SoeT5nlNzNc_LCXhCAbarKr0R-gRh5rXx8XU";
